import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'

// Importing Pages
import LandingPage from '@/pages'
import Home from '@/pages/Home'
import superAdmin from '@/pages/SuperAdmin'
import dashboard from '@/pages/SuperAdmin/dashboard'
import meterResetManager from '@/pages/Admin/meterReset'


import openSession from '@/pages/Admin/openSession'
import completedSession from '@/pages/Admin/completedSession'
import completedSessionView from '@/pages/Admin/completedSessionView'
import mailing from '@/pages/Admin/mailing'
import manageAddressBook from '@/pages/Admin/manageAddressBook'
import manageMobileUsers from '@/pages/Admin/manageMobileUsers'
import adhocSession from '@/pages/Admin/adhocSession'
import changePassword from '@/pages/Admin/changePassword'
import addAdhocSession from '@/pages/Admin/addAdhocSession'

import serviceProvider from '@/pages/SuperAdmin/serviceProvider'
import serviceProviderManagement from '@/pages/SuperAdmin/manageServiceProvider'
import siteManagement from '@/pages/SuperAdmin/siteManagement'
import addNewSite from '@/pages/SuperAdmin/addNewSite'
import rateManagement from '@/pages/SuperAdmin/rateManagement'
import siteDetailView from '@/pages/SuperAdmin/siteDetailView'
import laravelLogs from '@/pages/SuperAdmin/laravelLogs'


import adminLogin from '@/pages/Authenticaion/adminLogin'
import forgotPassword from '@/pages/Authenticaion/forgotPassword'
import billSearch from '@/pages/Admin/billSearch'
import sitePreferences from '@/pages/Admin/sitePreferences'


Vue.use(Router)

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    console.log(to.name, from.name)
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      redirect: '/login',
    }, {
      path: '/',
      redirect: '/login',
    }, {
      path: '/login',
      name: 'adminLogin',
      component: adminLogin,
    }, {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: forgotPassword,
    }, {
      path: '/dashboard',
      // name: 'LandingPage',
      component: LandingPage,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: Home,
        }, {
          path: '/open-session',
          name: 'openSession',
          component: openSession,
        }, {
          path: '/completed-session',
          name: 'completedSession',
          component: completedSession,
        }, {
          path: '/completed-session-view',
          name: 'completedSessionView',
          component: completedSessionView,
        }, {
          path: '/all-mailing',
          name: 'mailing',
          component: mailing,
        }, {
          path: '/manage-address-book',
          name: 'manageAddressBook',
          component: manageAddressBook,
        }, {
          path: '/manage-mobile-users',
          name: 'manageMobileUsers',
          component: manageMobileUsers,
        }, {
          path: '/adhoc-session',
          name: 'adhocSession',
          component: adhocSession
        }, {
          path: '/add-adhoc-session',
          name: 'addAdhocSession',
          component: addAdhocSession
        }, {
          path: '/change-password',
          name: 'changePassword',
          component: changePassword
        },
        {
          path: '/meter-reset',
          name: 'meterResetManager',
          component: meterResetManager
        },
        {
          path: '/bill-search',
          name: 'billSearch',
          component: billSearch
        },
        {
          path: '/site-preferences',
          name: 'sitePreferences',
          component: sitePreferences
        },
      ]
    }, {
      path: '/super-admin',
      // name: 'superAdmin',
      component: superAdmin,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: dashboard,
        }, {
          path: '/service-provider',
          name: 'serviceProvider',
          component: serviceProvider
        }, 
        {
          path: '/manage-service-provider',
          name: 'editServiceProvider',
          component: serviceProviderManagement,
          props: true
        },
        {
          path: '/site-management',
          name: 'siteManagement',
          component: siteManagement
        }, {
          path: '/add-new-site',
          name: 'addNewSite',
          component: addNewSite
        }, {
          path: '/site-detail-view/:serviceproviderid/:servicetypeid/:siteid/',
          name: 'siteDetailView',
          component: siteDetailView
        }, {
          path: '/rate-management',
          name: 'rateManagement',
          component: rateManagement
        }, {
          path: '/laravel-logs',
          name: 'laravelLogs',
          component: laravelLogs
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const adminRouteNames = [
    'openSession',
    'completedSession',
    'completedSessionView',
    'mailing',
    'manageAddressBook',
    'manageMobileUsers',
    'adhocSession',
    'addAdhocSession',
    'changePassword',
    'meterResetManager',
    'billSearch',
    'sitePreferences'
  ]
  const superAdminRouteNames = [
    'dashboard',
    'serviceProvider',
    'editServiceProvider',
    'siteManagement',
    'addNewSite',
    'siteDetailView',
    'rateManagement',
    'laravelLogs'
  ]
  function checkToken (value) {
    if (!localStorage.token) {
      localStorage.clear()
      next({
        name: 'adminLogin'
      })
    } else {
        if(localStorage.getItem('roleId') == value){
          next();
        } else {
          next({
            name: 'adminLogin'
          });
        }
    }
  }
  if (!to.matched.length) {
    NProgress.start()
    next({ name: 'adminLogin' })
    NProgress.done()
  } else if (to.path.includes('/dashboard') || adminRouteNames.includes(to.name)) {
    NProgress.start()
    checkToken(2)
    NProgress.done()
  } else if (to.path.includes('/super-admin') || superAdminRouteNames.includes(to.name)) {
    NProgress.start()
    checkToken(1)
    NProgress.done()
  } else {
    NProgress.start()
    next()
    NProgress.done()
  }
})
router.afterEach((to, from) => {
  NProgress.done()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js